import { themeTextColor } from "@/utils/colorConstant";
import {
  UserIcon,
  PencilSquareIcon,
  TrashIcon,
  XCircleIcon,
  ArrowUturnRightIcon,
  ArrowUpRightIcon,
  MapPinIcon,
  MagnifyingGlassIcon,
  AdjustmentsVerticalIcon,
  PlusIcon,
  MinusIcon,
  HandThumbUpIcon,
  ChatBubbleLeftIcon,
  ArrowLeftIcon,
  ArrowRightEndOnRectangleIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  ChevronRightIcon,
  EllipsisHorizontalIcon,
  ArrowPathRoundedSquareIcon,
  ChatBubbleLeftEllipsisIcon,
  ShareIcon,
  CameraIcon,
  ArrowTopRightOnSquareIcon,
  LinkIcon,
  EnvelopeIcon,
  PhoneIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/outline";
import { HandThumbUpIcon as HandThumbUpIconS } from "@heroicons/react/24/solid";

type IconProps = {
  className?: string;
};

export const UserIc = ({ className }: IconProps) => {
  return <UserIcon className={className} />;
};

export const EditIc = ({ className }: IconProps) => {
  return <PencilSquareIcon className={className} />;
};

export const DeleteIc = ({ className }: IconProps) => {
  return <TrashIcon className={className} />;
};

export const CrossIc = ({ className }: IconProps) => {
  return <XCircleIcon className={className} />;
};

export const RotateIc = ({ className }: IconProps) => {
  return <ArrowUturnRightIcon className={className} />;
};

export const ArrowUpRightIc = ({ className }: IconProps) => {
  return <ArrowUpRightIcon className={className} />;
};

export const MapPinIc = ({ className }: IconProps) => {
  return <MapPinIcon className={className} />;
};

export const SearchIc = ({ className }: IconProps) => {
  return <MagnifyingGlassIcon className={className} />;
};

export const FilterIc = ({ className }: IconProps) => {
  return <AdjustmentsVerticalIcon className={className} />;
};

export const PlusIc = ({ className }: IconProps) => {
  return <PlusIcon className={className} />;
};

export const MinusIc = ({ className }: IconProps) => {
  return <MinusIcon className={className} />;
};

export const ThumbIc = ({ className }: IconProps) => {
  return <HandThumbUpIcon className={className} />;
};

export const ThumbIcS = ({ className }: IconProps) => {
  return <HandThumbUpIconS className={className} />;
};

export const CommentIc = ({ className }: IconProps) => {
  return <ChatBubbleLeftIcon className={className} />;
};

export const BackIc = ({ className }: IconProps) => {
  return <ArrowLeftIcon className={className} />;
};

export const LogoutIc = () => {
  return (
    <ArrowRightEndOnRectangleIcon className={`h-8 w-8 ${themeTextColor}`} />
  );
};

export const ChevronDownIc = ({ className }: IconProps) => {
  return <ChevronDownIcon className={className} />;
};

export const ChevronUpIc = ({ className }: IconProps) => {
  return <ChevronUpIcon className={className} />;
};

export const ChevronRightIc = ({ className }: IconProps) => {
  return <ChevronRightIcon className={className} />;
};

export const EllipsisHorizontalIc = ({ className }: IconProps) => {
  return <EllipsisHorizontalIcon className={className} />;
};

export const TranslateIc = ({ className }: IconProps) => {
  return <ArrowPathRoundedSquareIcon className={className} />;
};

export const ReportContentIc = ({ className }: IconProps) => {
  return <ChatBubbleLeftEllipsisIcon className={className} />;
};

export const ShareIc = ({ className }: IconProps) => {
  return <ShareIcon className={className} />;
};

export const CameraIc = ({ className }: IconProps) => {
  return <CameraIcon className={className} />;
};

export const SendIc = ({ className }: IconProps) => {
  return <ArrowTopRightOnSquareIcon className={className} />;
};

export const LinkIc = ({ className }: IconProps) => {
  return <LinkIcon className={className} />;
};

export const MailIc = ({ className }: IconProps) => {
  return <EnvelopeIcon className={className} />;
};

export const PhoneIc = ({ className }: IconProps) => {
  return <PhoneIcon className={className} />;
};

export const SettingIc = () => {
  return <Cog6ToothIcon className={`h-8 w-8 ${themeTextColor}`} />;
};
